export const API = '/api';

export const apiUrl = (path = '') => {
  const normalized = String(path).replace(/^\/+/, '');
  return normalized ? `${API}/${normalized}` : API;
};

export const siteUrl = (path = '') => {
  const normalized = String(path).replace(/^\/+/, '');
  return normalized ? `/${normalized}` : '/';
};
